import { Container } from './styles'

export default function GachaLayout({ children }: { children: React.ReactNode }) {
  return <Container>{children}</Container>
}
